import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {
  Observable,
  catchError,
  from,
  map,
  of,
  switchMap,
  throwError,
} from "rxjs";
import {
  Database,
  equalTo,
  listVal,
  orderByChild,
  query,
  ref,
  push,
  set,
  get,
} from "@angular/fire/database";
import { IModoEntrada } from "../../../interfaces/catalogos.";
@Injectable({
  providedIn: "root",
})
export class ModoEntradaService {
  private database: Database = inject(Database);

  cargarModoEntrada(): Observable<IModoEntrada[]> {
    const refCatalogo = ref(this.database, "catalogos/modo_entrada");
    const refQuery = query(refCatalogo, orderByChild("activo"), equalTo(true));
    return listVal(refQuery, { keyField: "id" }).pipe(
      map((modos: unknown[]) => {
        const modosEntrada = modos as IModoEntrada[];
        return modosEntrada.sort((a, b) =>
          a.descripcion.localeCompare(b.descripcion)
        );
      })
    );
  }

  guardarModo(descripcion: string): Observable<{ error: boolean }> {
    const refCatalogo = ref(this.database, "catalogos/modo_entrada");
    const modoEntradaaRef = push(refCatalogo);
    const modoEntrada: IModoEntrada = {
      activo: true,
      descripcion,
      id: modoEntradaaRef.key || "",
    };

    return from(set(modoEntradaaRef, modoEntrada)).pipe(
      map(() => ({ error: false })),
      catchError((error) => {
        console.error(error);
        return of({ error: true });
      })
    );
  }
  editarModo(modo_entrada: IModoEntrada): Observable<{ error: boolean }> {
    const refModo = ref(
      this.database,
      `catalogos/modo_entrada/${modo_entrada.id}`
    );

    return from(get(refModo)).pipe(
      switchMap((modoSnapshot) => {
        if (modoSnapshot.exists()) {
          const editarModo = modoSnapshot.val();
          editarModo.descripcion = modo_entrada.descripcion;
          return from(set(refModo, editarModo)).pipe(
            map(() => ({ error: false }))
          );
        } else {
          return throwError(() => new Error("El modo no existe."));
        }
      }),
      catchError((error) => {
        console.error(error);
        return of({ error: true });
      })
    );
  }

  eliminarModo(id: string): Observable<{ error: boolean }> {
    const refModoEntrada = ref(this.database, `catalogos/modo_entrada/${id}`);

    return from(get(refModoEntrada)).pipe(
      switchMap((modoSnapshot) => {
        if (modoSnapshot.exists()) {
          const nuevoModo = modoSnapshot.val();
          nuevoModo.activo = false;
          return from(set(refModoEntrada, nuevoModo)).pipe(
            map(() => ({ error: false })), // No error
            catchError(() => of({ error: true })) // Error occurred
          );
        } else {
          throw new Error("El modo no existe.");
        }
      }),
      catchError(() => of({ error: true })) // Error occurred
    );
  }
}
